"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRule = createRule;
exports.generateIndividualReport = generateIndividualReport;
exports.generateSummaryReport = generateSummaryReport;
exports.generateTASCreditReport = generateTASCreditReport;
exports.getJobs = getJobs;
exports.getRuleList = getRuleList;
exports.releaseJob = releaseJob;
exports.updateRule = updateRule;
var _request = _interopRequireDefault(require("@/utils/request"));
function getRuleList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/rule',
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers,
    params: query
  });
}
function updateRule(token, obj) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/rule/' + obj.id,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'put',
    headers,
    data: obj
  });
}
function createRule(token, obj) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/rule',
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'post',
    headers,
    data: obj
  });
}
function generateIndividualReport(token, year, week, raterId, tenant) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const query = {};
  if (tenant) {
    query.tenant = tenant;
  }
  return (0, _request.default)({
    url: `/rater-assignment/individual-jobs-report/${raterId}/year/${year}/week/${week}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers,
    params: query
  });
}
function generateSummaryReport(token, year, week, tenant) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const query = {};
  if (tenant) {
    query.tenant = tenant;
  }
  return (0, _request.default)({
    url: `/rater-assignment/jobs-summary-report/year/${year}/week/${week}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers,
    params: query
  });
}
function generateTASCreditReport(token, obj, tenant) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const query = {};
  if (tenant) {
    query.tenant = tenant;
  }
  return (0, _request.default)({
    url: `/rater-assignment/tas-credit-report`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'post',
    headers,
    data: obj,
    params: query
  });
}
function getJobs(token, startFrom, startTo) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/rater-assignment/job/all?startFrom=${startFrom}&startTo=${startTo}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers
  });
}
function releaseJob(token, raterId, jobId, userHikeId, stageId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/rater-assignment/job-release/raterId/${raterId}/jobId/${jobId}/userHikeId/${userHikeId}/stageId/${stageId}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'put',
    headers
  });
}